import { render, staticRenderFns } from "./contact-replay.vue?vue&type=template&id=b84d9834&scoped=true&"
import script from "./contact-replay.vue?vue&type=script&lang=js&"
export * from "./contact-replay.vue?vue&type=script&lang=js&"
import style0 from "./contact-replay.vue?vue&type=style&index=0&id=b84d9834&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84d9834",
  null
  
)

export default component.exports